import Product from "./Product";

export default class InvoiceLineItemModel {
    unitPrice: number;
    amount: number;
    description: string;
    discountAmount: number;
    discountDescription: string;
    createdDate: string;
    product: Product;
    isRefunded: boolean;

    constructor(unitPrice: number, amount: number, createdDate: string, description: string,
                discountAmount: number, discountDescription: string, product: Product, isRefunded: boolean) {
        this.unitPrice = unitPrice;
        this.amount = amount;
        this.createdDate = createdDate;
        this.description = description;
        this.discountAmount = discountAmount;
        this.discountDescription = discountDescription;
        this.product = product;
        this.isRefunded = isRefunded;
    }
}